export default __webpack_public_path__ + "static/about-footer-118453930a73d73a177d436d37d3075c.jpg";